import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"

const options = {
  position: "top-center",
  timeout: TOAST_TIMER,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
}

export default function (app) {
  app.use(Toast, options)
}

